import { Table } from 'antd'
import { applicationsColumns } from './config'
import { ApplicationsState } from '@/state'
import { computed, ReadonlySignal, Signal, signal } from '@preact/signals-react'

import { LazyLoad } from '@/components/suspense/LazyLoad'
import { TApplication } from '@/interfaces'

import './styles.scss'

export const hoverRow: Signal<string | null> = signal(null)
export const loadingAppsTable: ReadonlySignal<boolean> = computed(
  () =>
    ApplicationsState.loading.value.getAll ||
    Boolean(ApplicationsState.loading.value.getById) ||
    Boolean(ApplicationsState.loading.value.changeStatus.id) ||
    Boolean(ApplicationsState.loading.value.deletingRow)
)

export default function ApplicationsTable() {
  function onRow(record: TApplication) {
    return {
      onMouseEnter: () => {
        hoverRow.value = record.id as string
      },
      onMouseLeave: () => {
        hoverRow.value = null
      },
    }
  }

  function renderTotalInfo(
    totalItems: number,
    [initPos, endPos]: [number, number]
  ) {
    return `${initPos} a ${endPos} de ${totalItems}`
  }

  return (
    <Table
      rowKey='id'
      size='small'
      className='applications-table'
      columns={applicationsColumns}
      dataSource={ApplicationsState.filteredApplications.value}
      loading={{
        spinning: loadingAppsTable.value,
        indicator: <LazyLoad inside />,
      }}
      pagination={{
        responsive: true,
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 20, 50, 100, 200],
        locale: {
          items_per_page: ' registros',
          jump_to: 'ir a',
          page: 'página',
        },
        showTotal: renderTotalInfo,
      }}
      onRow={onRow}
    />
  )
}
